/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DestroySavedItemMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type DestroySavedItemMutation = {
  __typename?: "Mutation";
  savedItemDestroy?: {
    __typename?: "SavedItemDestroyPayload";
    result: {
      __typename?: "SavedItemDestroyResult";
      sku: { __typename?: "SavedItemSku"; id: string };
    };
  } | null;
};

export const DestroySavedItemDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "destroySavedItem" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "savedItemDestroy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sku" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "id" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sku" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DestroySavedItemMutationFn = Apollo.MutationFunction<
  DestroySavedItemMutation,
  DestroySavedItemMutationVariables
>;

/**
 * __useDestroySavedItemMutation__
 *
 * To run a mutation, you first call `useDestroySavedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroySavedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroySavedItemMutation, { data, loading, error }] = useDestroySavedItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroySavedItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DestroySavedItemMutation,
    DestroySavedItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DestroySavedItemMutation, DestroySavedItemMutationVariables>(
    DestroySavedItemDocument,
    options,
  );
}
export type DestroySavedItemMutationHookResult = ReturnType<typeof useDestroySavedItemMutation>;
export type DestroySavedItemMutationResult = Apollo.MutationResult<DestroySavedItemMutation>;
export type DestroySavedItemMutationOptions = Apollo.BaseMutationOptions<
  DestroySavedItemMutation,
  DestroySavedItemMutationVariables
>;
